import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DeviceMaintenanceComponent } from './device-maintenance.component';

const routes: Routes = [
  {
    path:'',
    component: DeviceMaintenanceComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DeviceMaintenanceRoutingModule { }
